/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { Typography } from '@eventbrite/marmalade';
import { gettext } from '@eventbrite/i18n';
import { getTestimonialsDataByTld } from './pricingAndPackagingUtils';

import styles from './TestimonialBlock.module.scss';

export const TestimonialBlock = () => {
    const TestimonialsByTLD = getTestimonialsDataByTld();
    return (
        <section className={styles.testimonials_container}>
            <div className={styles.testimonial_block}>
                <Typography
                    variant="heading-lg"
                    className={styles.testimonial_heading}
                >
                    {gettext('Hear what our organizers are saying')}
                </Typography>

                <div className={styles.testimonial_cards}>
                    {TestimonialsByTLD.map(
                        ({ quote, attribution, image, link }, idx) => {
                            return (
                                <div
                                    key={`${attribution}-${idx}`}
                                    className={styles.testimonial_card}
                                >
                                    <Typography
                                        variant="heading-sm"
                                        as="p"
                                        className={styles.testimonial_quote}
                                    >
                                        {quote}
                                    </Typography>
                                    <div className={styles.testimonial_user}>
                                        {image && (
                                            <div
                                                className={
                                                    styles.testimonial_avatar_div
                                                }
                                            >
                                                <img
                                                    src={image}
                                                    alt={attribution}
                                                />
                                            </div>
                                        )}
                                        <Typography variant="body-md">
                                            <a href={link} target="_blank">
                                                {attribution}
                                            </a>
                                        </Typography>
                                    </div>
                                </div>
                            );
                        },
                    )}
                </div>
            </div>
        </section>
    );
};
